import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { formatDate } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { process, State } from '@progress/kendo-data-query';
import { LoaderService } from '../../../core/services/loader.service';
import { SharedService } from '../../../shared/shared.service';
import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import {
  getBillHistoryExportResponse,
  getBillHistoryResponse,
} from '../../../store/customer/consumer-selector';
import {
  getBillHistory,
  getBillHistoryExport,
  resetBillHistoryState,
} from '../../../store/customer/consumer.action';
import { table_pageSize } from '../../../shared/constants/templatesNames';

import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { ModeOfPaymentsAutoPay, SweetAlertIcon } from '../../../shared/constants/enum';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../shared/notification.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Helper } from '../../../core/helpers/helper';
import _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PaymentService } from '../../../core/services/payment.service';
import { AppConfigData } from '../../../core/config/appConfigData';
declare var Razorpay: any;
@Component({
  selector: 'app-rp-bill-history',
  standalone: false,
  templateUrl: './rp-bill-history.component.html',
  styleUrl: './rp-bill-history.component.scss',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .k-grid .k-grid-content td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class RpBillHistoryComponent {
  public selectableSettings!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  modelRef_1!: BsModalRef;
  AutoPaymodelRef_1!: BsModalRef;
  public mode: SelectableMode = 'multiple';
  public filterMode: FilterableSettings = 'row';
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  projectId: any;
  ModeOfPaymentsAutoPay = ModeOfPaymentsAutoPay;
  consumerId: any;
  currentUser: any;
  public pageSizes = table_pageSize.pageSizes;
  //public pageSizes = true;
  public previousNext = true;
  public billHistoryState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  fromDate: any = [];
  billdate: any = [];
  public sort: SortDescriptor[] = [];
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  orderByQuery: string = '';
  queryString: string = '';
  searchedValue: any = '';
  exportData: any[] = [];
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  public pageSize = 10;
  public skip = 0;
  billHistoryList: any[] = [];
  totalUserCount: number = 0;
  currentPage: number = 1;

  breadCrumbItems: Array<{}> | undefined;
  datePickerConfig: Partial<BsDatepickerConfig>;
  public billHistoryData: GridDataResult = { data: [], total: 0 };
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  billType: any;
  userPhone: any;
  userName: any;
  selectedPaymentMode: any;
  isAutoPayForBills: boolean = false;
  private billhistorySubscription: Subscription;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    private paymentService: PaymentService,
    private loaderService: LoaderService,
    private store: Store,
    private sharedService: SharedService,
    private PdfexportService: PdfexportService,
    private notificationService: NotificationService
  ) {
    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'DD/MM/YYYY', // Set to dd/MM/yyyy format
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
      }
    );
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.isFilter = localStorage.getItem('filter');
    this.consumerId = this.currentUser?.currentUserRoleDetails?.userId;
    this.userName = this.currentUser.currentUserRoleDetails.userName;
    this.userPhone = this.currentUser.currentUserRoleDetails.phone;
    this.projectId = this.currentUser?.project.id;
    this.isAutoPayForBills =
      this.currentUser.currentUserRoleDetails.isAutoPayForBills;
    this.breadCrumbItems = [{ label: 'Bill History' }];
    console.log('history.state.billType----------->', history.state);
    if (
      history.state.billType != undefined &&
      history.state.billType !== null
    ) {
      this.billType = history.state.billType;

      // this.residentialunitRequest = history.state.residentialUnitRequest;
    }
    if (history.state.info != undefined && history.state.info !== null) {
      this.updateBillHistoryPage(history.state.info);

      // this.residentialunitRequest = history.state.residentialUnitRequest;
    }

    this.billhistorySubscription =
      this.notificationService.billHistoryUpdate$.subscribe((data) => {
        console.log('this.billType----------->', data);
        this.updateBillHistoryPage(data);
      });
    this.getbillHistoryStoreInfo();
  }
  clearDate() {
    this.queryString = '';
    this.fromDate = []; // Clear the selected date
    this.getBillHistory();
  }

  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/YYYY', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/YYYY', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  /*  onCheckboxChange(event: any) {
    const target = event.target as HTMLInputElement;
    const isChecked = target?.checked ?? false;
   

      console.log('Checkbox value:', isChecked);
    let text = isChecked ? 'Auto Pay Enabled' : 'Auto Pay Disabled';
    this.sharedService
      .showConfirmMessageDialog(
        'Are you sure?', 
        text, 
        SweetAlertIcon.WARNING 
      )
      .then((res) => {
        if (res.isConfirmed == true) {
          console.log(res.isConfirmed);
          let request = {
            ConsumerId: this.consumerId,
            IsEnableAutoPay: isChecked,
            Mode: 'card',
          };

          this.paymentService.setAutoPayBill(request).subscribe({
            next: (res) => {
              console.log(res);
              if (res.statusCode == 201) {
                 this.isAutoPayForBills = isChecked;
                   
              }
            },
            error: (err) => {
              console.log(err);
            },
          });
        } else {
         
          this.isAutoPayForBills = !isChecked;
          target.checked = !isChecked;
        }
      });
  } */
  autoPayRecharge(request: any) {
    this.modelRef_1.hide();
    this.paymentService.setAutoPayBill(request).subscribe({
      next: (response) => {
        const options = {
          key: AppConfigData.Razorpay_KeyId, // Replace with your Razorpay Key ID
          amount: response.data.amount * 100, // Amount in paise
          currency: 'INR',
          name: 'Ripple',
          customer_id: response.data.customer_id,
          recurring: '1',
          description: ' Auto pay',
          order_id: response.data.orderId, // This is a sample Order ID. Pass the `id` obtained in the previous step
          handler: (response: any) => {
            this.loaderService.setLoading(true);
          },
          prefill: {
            name: this.userName,
            // email: '',
            contact: this.userPhone,
          },
          notes: {
            address: '',
            IsRecharge: 0,
            IsBill: 1,
            isAutopPay: 1,
            // convenience_charge: '0',
          },
          config: {
            display: {
              /*  blocks: {
               convenience_charge: {
                 name: "Convenience Charge",
                 amount: 0 // Ensure convenience charge is 0
               }
             }, */
              hide: [
                { method: 'emi' },
                // { key: "convenience_charge" } // Hide convenience charge
              ],
            },
          },
          theme: {
            color: '#54bbf3',
          },
          modal: {
            escape: false,
            ondismiss: () => {
              console.log('orignal payment cancelled');
              this.OnPaymentFailure(response.data.orderId);
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Failure',
                'payment cancelled',
                SweetAlertIcon.ERROR
              );
            },
          },
        };
        const rzp1 = new Razorpay(options);
        rzp1.open();
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);
      },
    });
  }
  onPaymentChange(event: any) {
    console.log('Selected:', event); // full object if needed
    console.log('Selected ID:', this.selectedPaymentMode); // just ID
  }
  autopaychekbox(event: any) {
    console.log(event.target.checked);
  }
  OnPaymentFailure(orderId: any) {
    let request = {
      OrderId: orderId,
    };
    this.paymentService
      .paymentWalletFailure(request)
      .subscribe((response: any) => {});
  }
  rechargeByAutoPay(AutoPay: any) {
    this.modelRef_1 = this.modalService.show(AutoPay, {
      class: 'modal-dialog-centered',
      backdrop: 'static', //
    });
  }

  openCalendar() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }

  isFilter: any;
  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    if (
      this.billType &&
      typeof this.billType === 'object' &&
      Object.keys(this.billType).length > 0
    ) {
      if (this.isFilter == 'true') {
        this.filter = this.sharedService.getFilter();
        this.billHistoryState.filter = this.filter;

        this.queryString = this.sharedService.createQuery(
          this.billHistoryState
        );
      }

      if (this.billType.type == 'bills') {
       // this.pageSize = 5;

        //this.fromDashboardRecharge = history.state.Recharge;
         console.log(history.state.Recharge);
         console.log(this.billType.type);
        const rawDate = this.billType.date;

        // Parse manually to avoid timezone shifts
        const [day, monthStr, year] = rawDate.split(' ');
        const monthMap: Record<string, number> = {
          Jan: 0,
          Feb: 1,
          Mar: 2,
          Apr: 3,
          May: 4,
          Jun: 5,
          Jul: 6,
          Aug: 7,
          Sep: 8,
          Oct: 9,
          Nov: 10,
          Dec: 11,
        };
        const selectedDate = new Date(
          Date.UTC(+year, monthMap[monthStr], +day)
        );

        // Previous day end (21 Aug 23:59:59.999 UTC)
        const prevDayEnd = new Date(selectedDate);
        prevDayEnd.setUTCDate(selectedDate.getUTCDate() - 1);
        prevDayEnd.setUTCHours(23, 59, 59, 999);

        // Next day start (23 Aug 00:00:00.000 UTC)
        const nextDayStart = new Date(selectedDate);
        nextDayStart.setUTCDate(selectedDate.getUTCDate() + 1);
        nextDayStart.setUTCHours(0, 0, 0, 0);

        console.log(
          'Filter:',
          `paymentDate gt ${prevDayEnd.toISOString()} and paymentDate lt ${nextDayStart.toISOString()}`
        );

        this.billHistoryState = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentDate',
                    operator: 'gte',
                    value: new Date(prevDayEnd.toISOString()),
                  },
                  {
                    field: 'paymentDate',
                    operator: 'lte',
                    value: new Date(nextDayStart.toISOString()),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };

        this.queryString = `$filter=(paymentDate gt ${prevDayEnd.toISOString()} and paymentDate lt ${nextDayStart.toISOString()})`;
      }
      if (this.billType.type.toLowerCase() == 'paid') {
        let status = this.billType.type;

        this.billHistoryState = {
          skip: 0,
          take: 10,
          filter: {
            logic: 'and',
            filters: [
              { field: 'paymentStatus', operator: 'contains', value: 'UnPaid' },
            ],
          },
        };
        this.queryString = `$filter= contains(paymentStatus,'UnPaid')`;
      }


    }
    this.searchedValue = history.state.info ?? '';
    this.getBillHistory();
  }

  getBillHistory() {


    this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
      })
    );
  }

  public onValueChange(ev: string): void {
    if (ev.length == 0) {
      this.billHistoryonPageChange({ skip: 0, take: this.pageSize });
      this.getBillHistory();
      /*  this.store.dispatch(
         getBillHistory({
           pageIndex: this.currentPage,
           pageSize: this.pageSize,
           searchTerm: this.searchedValue,
           filter: this.queryString,
           orderBy: this.orderByQuery,
           ProjectId: this.projectId,
           FromDate:
             this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[0]) : '',
           ToDate:
             this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[1]) : '',
         })
       ); */
    }
  }

  onSearchBillHistory(): void {
    if (this.searchedValue.length > 0) {
      this.getBillHistory();
      /*  this.store.dispatch(
         getBillHistory({
           pageIndex: this.currentPage,
           pageSize: this.pageSize,
           searchTerm: this.searchedValue,
           filter: this.queryString,
           orderBy: this.orderByQuery,
           ProjectId: this.projectId,
           FromDate:
             this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[0]) : '',
           ToDate:
             this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[1]) : '',
         })
       ); */
    }
  }
  updateBillHistoryPage(data: any) {
    this.searchedValue = data;
    this.getBillHistory();
    /* this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
        FromDate:
          this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[0]) : '',
        ToDate:
          this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[1]) : '',
      })
    ); */
    // Trigger any additional logic needed to refresh the page
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();
      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }
  private exportSubscription: Subscription = new Subscription();
  getbillHistoryStoreInfo() {
    this.store.dispatch(resetBillHistoryState());
    let getBillHistory$ = this.store.pipe(select(getBillHistoryResponse));
    this.exportSubscription = this.store
      .pipe(select(getBillHistoryExportResponse))
      .subscribe((res: any) => {
        if (res) {
          this.exportData = [];
          if (res.items.length > 0) {
            this.exportData = [...res.items];
            const transformedData = this.exportData?.map((item: any) => ({
              'Bill Number': item.billNo,
              'Payment ID': item.transactionId,
              'Residential Unit': item.residentialUnit,
              'Bill Date': formatDate(item.billDate, 'dd MMM yyyy', 'en-US'),
              'Payment Date':
                item.paymentDate == '0001-01-01T00:00:00'
                  ? '-'
                  : formatDate(
                      item.paymentDate,
                      'dd MMM yyyy hh:mm a',
                      'en-US'
                    ),
              Utility: item.utility,
              'Meter No': item.macAddress,
              'Bill Amount': item.totalAmount,
              'Mode of Payment': item.modeOfPayment,
              'Payment Status': item.paymentStatus,
            }));
            this.PdfexportService.downloadExcel(
              transformedData,
              'Bill History'
            );
          } else {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }
        }
      });

    getBillHistory$.subscribe((data: any) => {
      if (data) {
        this.billHistoryList = [...data.items];

        this.pageSize = data.pageSize;
        this.totalUserCount = data.totalCount;
        this.loadGridTable();
      }
    });
  }
  ngOnDestroy() {
    if (this.billhistorySubscription) {
      this.billhistorySubscription.unsubscribe();
    }
    this.exportSubscription.unsubscribe(); // Or set it to [] if you prefer an empty array
  }
  loadGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
      // filter: this.filter,
    };
    const processedData = process(this.billHistoryList, state);
    this.billHistoryData = {
      data: this.billHistoryList,
      total: this.totalUserCount,
    };
    this.billHistoryData.data = this.billHistoryData?.data.map((item) => {
      //  console.log(item.paymentDate);
      return {
        ...item,
        paymentDate:
          item.paymentDate == '0001-01-01T00:00:00'
            ? '-'
            : formatDate(item.paymentDate, 'dd MMM yyyy hh:mm a', 'en-US'),
        billDate:
          item.billDate == '0001-01-01T00:00:00'
            ? '-'
            : formatDate(item.billDate, 'dd MMM yyyy', 'en-US'),
      };
    });
    //  console.log(this.billHistoryData.data)

    //this.loaderService.setLoading(false);
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.billHistoryState.sort = sort;
    // console.log(this.billHistoryState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.billHistoryState.sort
    );

    this.orderByQuery = orderByQuery;
    this.getBillHistory();
    /* this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
        FromDate:
          this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[0]) : '',
        ToDate:
          this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[1]) : '',
      })
    ); */
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];

  async onBillFilterChange(filter: CompositeFilterDescriptor) {
    this.billHistoryState.filter = filter;
    this.skip = 0;
   
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.billHistoryState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.billHistoryState
    );
    //  console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        // console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          // console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
      //console.log("gasQueryString", this.queryString)
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    //const queryString = this.sharedService.createQuery(this.billHistoryState);
    // this.queryString = this.sharedService.createQuery(this.billHistoryState);
    this.getBillHistory();
  }

  filterBasedOnDate(flag: number) {
    //  console.log(this.fromDate)
    /*   if (flag == 0) {
        this.fromDate = [];
        //  this.queryString = `$filter=(billDate ge ${Helper.formatDate(this.fromDate[0])} and billDate le ${Helper.formatDate(this.fromDate[1])})`;
      } */

    if (flag === 0) {
      this.fromDate = [];
      this.queryString = '';
    } else {
      const formattedStartDate = this.fromDate[0].toISOString().split('T')[0];
      const formattedEndDate = this.fromDate[1].toISOString().split('T')[0];

      // Construct the query string with the formatted dates (yyyy-MM-dd)
      this.queryString = `$filter=(billDate ge ${formattedStartDate} and billDate le ${formattedEndDate})`;
    }
    this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
      })
    );
    /* this.store.dispatch(
          getConsumerRechargeHistory({
            pageIndex: this.currentPage,
            pageSize: this.pageSize,
            searchTerm: this.searchedValue,
            filter: this.queryString,
            orderBy: this.orderByQuery,
            ProjectId: this.projectId,
          })
    ) */
    // FromDate:this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[0]) : '',

    //ToDate:  this.fromDate.length > 0 ? Helper.formatDate(this.fromDate[1]) : '',
  }
  /*  selectDates(event: any) {
   
     if (event == undefined) {
       this.fromDate = [];
       this.queryString = ''
       this.store.dispatch(
         getBillHistory({
           pageIndex: this.currentPage,
           pageSize: this.pageSize,
           searchTerm: this.searchedValue,
           filter: this.queryString,
           orderBy: this.orderByQuery,
           ProjectId: this.projectId,
         })
       );
     }
   } */

  protected billHistoryonPageChange({ skip, take }: PageChangeEvent): void {
    // console.log('>>>', skip, take);
    this.selectedRowdata = [];
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    //  console.log('currentpage', Math.floor(skip / take) + 1);
    this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
      })
    );

    this.loadGridTable();
  }

  protected billHostoryStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadGridTable();
  }

  selectedRowdata: any = [];
  deselectedRowdata: any = [];
  onSelect(event: any) {
    // console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.selectedRowdata.push(element.dataItem);
        //  console.log(' selected Values : ', this.selectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.deselectedRowdata.push(element.dataItem);
        //   console.log('deselectedRowdata Values : ', this.deselectedRowdata);
      });

      if (this.deselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.deselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.selectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        console.log('', filteredArray);
        this.selectedRowdata = filteredArray;
      }
    }
  }

  public onFilter(value: Event): void {
    this.loaderService.setLoading(true);
    // const inputValue = value;
    // this.searchedValue = value;
    this.billHistoryonPageChange({ skip: 0, take: this.pageSize });
    this.store.dispatch(
      getBillHistory({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        ProjectId: this.projectId,
      })
    );
  }
  exportAll() {
    this.store.dispatch(
      getBillHistoryExport({ ProjectId: this.projectId, criteria: 'All' })
    );
  }
  onExport(type: string) {
    /* if (this.selectedRowdata.length == 0) {
      this.store.dispatch(getBillHistoryExport({ ProjectId: this.projectId, criteria: 'All', }));
    } */
    if (type === 'Excel') {
      if (this.billHistoryData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }

  onViewClick(item: any) {
    this.router.navigate(['/billHistory/billDetail'], {
      state: { billHostorydeatils: item },
    });
  }

  downloadbillsumary(data: any) {
    //event.stopPropagation();
    var temp = {
      id: data.billNo,
      status: data.paymentStatus,
      // paymentId: data.transactionId
    };
    //downloadBillsPayment

    this.sharedService.downloadBillsPayment(temp).subscribe({
      next: (blob: Blob) => {
        //  const contentDisposition = blob.type === 'application/pdf' ? `attachment; filename="${}"` : null;
        // let filename = `${data.billNo}.pdf`; // Default filename
        const sanitizedConsumerName = data.consumerName.replace(/\s+/g, '_'); // Replace spaces with underscores
        const sanitizedUnit = data.residentialUnit.replace(/\s+/g, '_'); // In case of spaces
        const filename = `Bill_${sanitizedConsumerName}_${sanitizedUnit}.pdf`;
        // If content disposition is available, extract filename
        /* s */
        if (blob) {
          this.loaderService.setLoading(false);
          console.log('Binary data received:', blob);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          this.loaderService.setLoading(false);
          console.error('Blob is null');
        }
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error('Error occurred:', err);
      },
    });
  }

  downloadBillsPaymentrecceipt(data: any) {
    //event.stopPropagation();
    var temp = {
      // id: data.billNo,
      //status: data.paymentStatus,
      paymentId: data.transactionId,
    };
    //downloadBillsPayment

    this.sharedService.downloadBillsPaymentrecceipt(temp).subscribe({
      next: (blob: Blob) => {
        //  const contentDisposition = blob.type === 'application/pdf' ? `attachment; filename="${}"` : null;
        //let filename = `${data.transactionId}.pdf`; // Default filename
        const sanitizedConsumerName = data.consumerName.replace(/\s+/g, '_'); // Replace spaces with underscores
        const sanitizedUnit = data.residentialUnit.replace(/\s+/g, '_'); // In case of spaces
        const filename = `Receipt_${sanitizedConsumerName}_${sanitizedUnit}.pdf`;
        // If content disposition is available, extract filename
        /* s */
        if (blob) {
          this.loaderService.setLoading(false);
          console.log('Binary data received:', blob);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          this.loaderService.setLoading(false);
          console.error('Blob is null');
        }
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error('Error occurred:', err);
      },
    });
  }

  preventManualInput(event: KeyboardEvent): void {
    // Prevent all keys except Tab and Arrow keys, which are essential for navigating
    const allowedKeys = [
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent input
    }
  }
}
